export default __webpack_public_path__ + "static/media/SensorThighLeft.4fbab61c.svg";